module.exports = __webpack_public_path__ + "img/instances-background.5a4b66f2.png";